import { ReceiptFormInfo } from '../../../model/ReceiptFormInfo';
import { api } from '../../../App';
import { parseReceiptFormInfo } from '../../../parsers/receiptFormInfo.parser';

export const getReceiptFormInfo = async (): Promise<ReceiptFormInfo> => {
  const response = await api.forms.apiFormInfoReceiptOrderGet();
  return parseReceiptFormInfo(response.data);
}
